
import { defineComponent } from "vue";

export default defineComponent({
  name: "UINoItems",
  props: {
    title: {
      type: String,
      required: false
    },
    numbersOfItems: {
      type: Number,
      required: true
    },
    hasAddButton: {
      type: Boolean,
      require: true,
      default: true
    }
  },
  methods: {
    addItem() {
      this.$emit("addItem");
    }
  }
});
